import React from 'react';
import { Card } from 'antd';
import { LineChartOutlined } from '@ant-design/icons';
import { colors } from '../../../../domain/types/colors';

import '../stats-card/StatCard.css';
import './CallsSmsMonthlyStatCard.css';

interface CallsSmsMonthlyStatCardProps {
  callsValue: number;
  smsValue: number;
  loading?: boolean;
}

// Separate thousands by a space
const formatCount = (n: number): string => n.toLocaleString('fr-FR');

const CallsSmsMonthlyStatCard: React.FC<CallsSmsMonthlyStatCardProps> = ({ callsValue, smsValue, loading }) => {
  return (
    <Card className="stat-card calls-sms-monthly-stat-card" loading={loading}>
      <div className="stat-card__header">
        <div className="stat-card__icon stat-card__icon--green calls-sms-monthly-stat-card__icon">
          <LineChartOutlined style={{ fontSize: 20, color: colors.primary.main }} />
        </div>
        <span className="stat-card__label">Activité du mois</span>
      </div>

      <div className="stat-card__body calls-sms-monthly-stat-card__body">
        <div className="calls-sms-monthly-stat-card__split">
          <div className="calls-sms-monthly-stat-card__item">
            <div className="stat-card__value-row">
              <span className="stat-card__value">{formatCount(callsValue)}</span>
            </div>
            <span className="stat-card__subtitle">appels sur le mois</span>
          </div>

          <div className="calls-sms-monthly-stat-card__divider" />

          <div className="calls-sms-monthly-stat-card__item">
            <div className="stat-card__value-row">
              <span className="stat-card__value">{formatCount(smsValue)}</span>
            </div>
            <span className="stat-card__subtitle">sms envoyés sur le mois</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CallsSmsMonthlyStatCard;
